import { useCallback } from "react";
import { ErrorModule } from "../../components/ErrorBoundary/ErrorBoundary";
import { scopesServiceButtonAction } from "../../redux/reducers/ScopesReducer/ScopesReducer";
import { useSelector } from "react-redux";
export const useScopesService = () => {
    const state = useSelector((s) => s.scopes);
    // A plain click handler, so the user can try again after closing the Microsoft window.
    const consent = useCallback(async () => {
        if (!scopesServiceButtonAction)
            return ErrorModule.showErrorAlert("Consent button action is undefined");
        await scopesServiceButtonAction();
    }, []);
    return {
        data: state,
        consent,
    };
};
export const checkConfig = (config) => {
    if (!config.scopes || config.scopes.length === 0)
        config.scopes = [".default"];
    if (!config.clientId)
        return ErrorModule.showErrorAlert("TeamsFx client id is invalid");
    if (!config.apiBaseUrl)
        return ErrorModule.showErrorAlert("TeamsFx api base url is invalid");
    if (config.apiBaseUrl.lastIndexOf('/') === config.apiBaseUrl.length - 1)
        config.apiBaseUrl = config.apiBaseUrl.substring(0, config.apiBaseUrl.length - 1);
};
